export default __webpack_public_path__ + "static/media/e-mail.abcd37db.svg";